export function loadGTM() {
    setTimeout(function () {
        var selectedCountryAddress = JSON.parse(localStorage.getItem('tss-v2__selectedCountryAddress'));
        if (selectedCountryAddress && selectedCountryAddress.value && selectedCountryAddress.value.countryId === 223) {
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': 
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f); })(window,document,'script','dataLayer','GTM-PTH6XVLT');
        }
      },0)
}


//////////////////
// WEBPACK FOOTER
// ./static/js/loadGTM.js
// module id = 921
// module chunks = 113